import { now } from '@internationalized/date';

import { type Occurrence } from '@models';

const makeTestOccurrence = (override: Partial<Occurrence> = {}): Occurrence => {
  return {
    cost: null,
    createdAt: now('Europe/Madrid'),
    currency: null,
    habitId: crypto.randomUUID(),
    hasSpecificTime: true,
    id: crypto.randomUUID(),
    metricValues: [],
    occurredAt: now('Europe/Madrid'),
    photoPaths: [],
    stockUsages: [],
    timeZone: 'Europe/Madrid',
    updatedAt: null,
    userId: crypto.randomUUID(),
    habit: {
      iconPath: 'default.png',
      name: 'Test Habit Name',
      ...(override.habit || {}),
      metricDefinitions: [],
      trait: {
        color: '#000000',
        id: override.habit?.trait?.id || crypto.randomUUID(),
        name: 'Test Trait Name',
        ...(override.habit?.trait || {}),
      },
    },
    ...override,
  };
};

export default makeTestOccurrence;
